import { FC, useCallback, useEffect } from 'react'
import { SidebarGroups, SidebarGroupsTextSeparator, SidebarGroupsCreateCustomItem } from 'components/features/pfm/SidebarGroups/SidebarGroups'
import { FeedFilterMenuItemContainer } from 'components/features/socialFeed/FeedFilters/FeedFilterMenuItemContainer'
import { getRelationFilter } from 'helpers/feedHelpers'
import { YOUR_POSTS_FILTER, FEEDGROUPS_FILTERS } from 'constants/feed'
import { useStoreSelector, useStoreDispatch } from 'helpers/reactReduxHelpers'
import { peersRelationSelector, peersRelationIdSelector } from 'selectors/peergroupSelectors'
import { filterRelationsSelector, isAllFilterUpdatesLoadedSelector, allFeedFilterQueriesSelector } from 'selectors/feedSelectors'
import { getFiltersStatusActionCreator } from 'actions/feedActions'
import { isMemberPremiumSelector } from 'selectors/globalSelectors'
import { openSubscriptionPageActionCreator } from 'actions/floatingPanesActions'
import { destroy } from 'redux-form'
import { FORM_CREATE_CUSTOM_PEER_GROUP } from 'constants/forms'
import { showPeergroupCreateFormActionCreator } from 'actions/sidebarActions'
import isNumber from 'lodash/isNumber'
import { PremiumOnly } from 'components/features/pfm/PremiumOnly/PremiumOnly'

type FeedFiltersProps = {}

export const FeedFilters: FC<FeedFiltersProps> = (props) => {
  const {} = props

  const yourRelation = useStoreSelector(peersRelationSelector)
  const otherRelations = useStoreSelector(filterRelationsSelector)

  const isAllFilterUpdatesLoaded = useStoreSelector(isAllFilterUpdatesLoadedSelector)
  const isFiltersStatusLoading = useStoreSelector((state) => state.app.feed.isFiltersStatusLoading)
  const allFilterQueries = useStoreSelector(allFeedFilterQueriesSelector)

  const dispatch = useStoreDispatch()
  const onLoadFiltersStatus = useCallback(() => {
    dispatch(getFiltersStatusActionCreator.request(allFilterQueries))
  }, [dispatch, allFilterQueries])

  const ensureFiltersStatus = useCallback(() => {
    if (!isAllFilterUpdatesLoaded && !isFiltersStatusLoading) {
      onLoadFiltersStatus()
    }
  }, [
    isAllFilterUpdatesLoaded,
    isFiltersStatusLoading,
    onLoadFiltersStatus,
  ])

  const isMemberPremium = useStoreSelector(isMemberPremiumSelector)
  const handleCreateGroupClick = useCallback(() => {
    if (!isMemberPremium) {
      dispatch(openSubscriptionPageActionCreator())
      return
    }

    dispatch(destroy(FORM_CREATE_CUSTOM_PEER_GROUP))
    dispatch(showPeergroupCreateFormActionCreator())
  }, [dispatch, isMemberPremium])

  useEffect(() => {
    ensureFiltersStatus()
  })

  const peersRelationId = useStoreSelector(peersRelationIdSelector)

  if (!yourRelation) {
    return null
  }

  return (
    <SidebarGroups>
      <FeedFilterMenuItemContainer
        filter={ YOUR_POSTS_FILTER }
        color='oxford'
        text='Your Posts'
        relationId='member'
      />

      <SidebarGroupsTextSeparator>View Posts For</SidebarGroupsTextSeparator>

      { isNumber(peersRelationId) && (
        <FeedFilterMenuItemContainer
          filter={ getRelationFilter(yourRelation) }
          color='coral'
          text={ yourRelation.name }
          relationId={ peersRelationId }
        />
      )}

      <FeedFilterMenuItemContainer
        filter={ FEEDGROUPS_FILTERS.everyone }
        color='merlot'
        text='Everyone'
        relationId='member'
      />

      { otherRelations.map((relation) => (
        <FeedFilterMenuItemContainer
          key={ relation.id }
          filter={ getRelationFilter(relation) }
          color='merlot'
          text={ relation.name }
          relationId={ relation.id }
        />
      )) }

      <SidebarGroupsCreateCustomItem onClick={ handleCreateGroupClick }>
        <PremiumOnly isBlocked={ !isMemberPremium }>
          Add Custom Group
        </PremiumOnly>
      </SidebarGroupsCreateCustomItem>

      <SidebarGroupsTextSeparator>View Posts From</SidebarGroupsTextSeparator>

      <FeedFilterMenuItemContainer
        filter={ FEEDGROUPS_FILTERS.followed_people }
        color='smoke'
        text='People You Follow'
        relationId='member'
      />

      <FeedFilterMenuItemContainer
        filter={ FEEDGROUPS_FILTERS.followed_tags }
        color='smoke'
        text='Tags You Follow'
        relationId='member'
      />

      <FeedFilterMenuItemContainer
        filter={ FEEDGROUPS_FILTERS.followed_posts }
        color='smoke'
        text='Posts You Follow'
        relationId='member'
      />
    </SidebarGroups>
  )
}
